module.exports = __webpack_public_path__ + "img/рз_belly_protuberance.977ec68e.png";